/* Lógica compartida del bloque de precio personalizado (blocks/price.liquid).
   Un solo archivo para todas las instancias: antes cada tarjeta emitía su
   propio <script> inline (~6,5 KB por tarjeta en las parrillas). */
(function () {
  'use strict';

  const currencyRegex = /\b[A-Z]{3}\b\s*/g;

  function stripCurrencyFromNode(node) {
    node.childNodes.forEach((child) => {
      if (child.nodeType === Node.TEXT_NODE) {
        const stripped = child.textContent.replace(currencyRegex, '').trim();
        if (stripped !== child.textContent) child.textContent = stripped;
      }
    });
  }

  function processPrices(block) {
    block.querySelectorAll('.price-item--regular, .compare-at-price').forEach((el) => {
      stripCurrencyFromNode(el);
      el.querySelectorAll('*').forEach((child) => stripCurrencyFromNode(child));
    });

    const showCurrency = block.dataset.showCurrency === 'true';
    if (!showCurrency) {
      block.querySelectorAll('.price-item--sale').forEach((el) => {
        stripCurrencyFromNode(el);
        el.querySelectorAll('*').forEach((child) => stripCurrencyFromNode(child));
      });
    }
  }

  function formatBadgeText(block, pct) {
    const format = block.dataset.badgeFormat;
    if (format === 'off_suffix') {
      return pct + '%OFF';
    }
    return '-' + pct + '%';
  }

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, '{{amount_with_comma_separator}} €');
    }
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function updateUnitPrice(block) {
    const unitEl = block.querySelector('.unit-price-per-unit');
    if (!unitEl) return;

    const packQty = parseFloat(block.dataset.pack);
    if (!packQty || packQty <= 0) return;

    const priceInCents = parseFloat(block.dataset.currentPrice);
    if (!priceInCents || isNaN(priceInCents)) return;

    const unitPriceCents = priceInCents / packQty;
    const formatted = formatMoney(unitPriceCents);
    const label = unitEl.dataset.unitLabel || '';

    unitEl.innerHTML = '';
    unitEl.appendChild(document.createTextNode(formatted));
    const span = document.createElement('span');
    span.className = 'unit-price-label';
    span.textContent = label;
    unitEl.appendChild(span);

    if (block.dataset.showCurrency !== 'true') {
      stripCurrencyFromNode(unitEl);
    }
  }

  function updateDiscountBadge(block, newPrice, comparePrice) {
    const badgeEl = block.querySelector('.discount-badge-custom');
    if (!badgeEl) return;
    if (!comparePrice || comparePrice <= newPrice) {
      badgeEl.style.display = 'none';
      return;
    }
    const pct = Math.round(100 - (newPrice * 100) / comparePrice);
    badgeEl.textContent = formatBadgeText(block, pct);
    badgeEl.style.display = '';
  }

  function updateSavingsLabel(block, newPrice, comparePrice) {
    const savingsEl = block.querySelector('.price-savings-label');
    if (!savingsEl) return;
    if (!comparePrice || comparePrice <= newPrice) {
      savingsEl.style.display = 'none';
      return;
    }
    const savingsCents = comparePrice - newPrice;
    savingsEl.textContent = 'Ahorras ' + formatMoney(savingsCents);
    savingsEl.style.display = '';

    if (block.dataset.showCurrency !== 'true') {
      stripCurrencyFromNode(savingsEl);
    }
  }

  function initBlock(block) {
    if (block.__priceCustomInit) return;
    block.__priceCustomInit = true;

    processPrices(block);
    updateUnitPrice(block);

    const observer = new MutationObserver(() => processPrices(block));
    observer.observe(block, { childList: true, subtree: true, characterData: true });
  }

  function initAll(root) {
    (root || document).querySelectorAll('product-price[data-block-id]').forEach(initBlock);
  }

  document.addEventListener('variant:change', (e) => {
    if (!e.detail || !e.detail.variant) return;
    const variant = e.detail.variant;
    if (variant.price === undefined) return;
    const productId = variant.product_id != null ? String(variant.product_id) : null;

    document.querySelectorAll('product-price[data-block-id]').forEach((block) => {
      // Si el evento identifica el producto, actualizamos solo sus bloques
      if (productId && block.dataset.productId && block.dataset.productId !== productId) return;
      block.dataset.currentPrice = variant.price;
      block.dataset.comparePrice = variant.compare_at_price || '';
      updateUnitPrice(block);
      updateDiscountBadge(block, variant.price, variant.compare_at_price);
      updateSavingsLabel(block, variant.price, variant.compare_at_price);
      setTimeout(() => processPrices(block), 50);
    });
  });

  // Instancias añadidas dinámicamente (morph de secciones, quick-add…)
  const docObserver = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const n of m.addedNodes) {
        if (n.nodeType !== 1) continue;
        if (n.matches && n.matches('product-price[data-block-id]')) initBlock(n);
        else if (n.querySelectorAll) n.querySelectorAll('product-price[data-block-id]').forEach(initBlock);
      }
    }
  });

  function start() {
    initAll();
    docObserver.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
